import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled", "aria-pressed", "aria-label"]


export default /*@__PURE__*/_defineComponent({
  __name: 'ScMark',
  props: {
    on: { type: Boolean },
    disabled: { type: Boolean },
    ariaLabel: {}
  },
  emits: ["pick"],
  setup(__props: any) {

/* 계약서 문서 안 ☐/☑ — 눌러서 켜고 끄는 체크·선택 마크 */




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(["sc-mark", { 'is-on': __props.on }]),
    disabled: __props.disabled,
    "aria-pressed": __props.on,
    "aria-label": __props.ariaLabel,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('pick')))
  }, _toDisplayString(__props.on ? '☑' : '☐'), 11, _hoisted_1))
}
}

})